"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Wrench = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Wrench_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.263 4.868a4.868 4.868 0 0 1 6.492-4.59c.553.195.636.87.27 1.236l-1.904 1.905a.509.509 0 0 0 0 .719l.741.741c.199.199.52.199.72 0l1.904-1.905c.365-.365 1.041-.282 1.237.271a4.868 4.868 0 0 1-6.265 6.196l-6.112 6.112a1.526 1.526 0 0 1-2.158 0l-.741-.741a1.526 1.526 0 0 1 0-2.158l6.112-6.112a4.86 4.86 0 0 1-.296-1.674Zm4.869-3.85A3.851 3.851 0 0 0 7.62 6.452l.145.32-6.6 6.6a.509.509 0 0 0 0 .72l.741.74c.2.2.521.2.72 0l6.6-6.599.32.145a3.851 3.851 0 0 0 5.34-4.367l-1.586 1.587a1.526 1.526 0 0 1-2.158 0l-.742-.742a1.526 1.526 0 0 1 0-2.158l1.587-1.586a3.866 3.866 0 0 0-.856-.096Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Wrench_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Wrench;
exports["default"] = _default;